module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "ETHKLogo.b79115fc.png";